import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { SecuritySettings } from '@/components/auth/security-settings';

export const Route = createFileRoute('/_app/settings/security')({
  component: SecuritySettingsPage,
});

function SecuritySettingsPage(): React.ReactElement {
  return (
    <section className="border-border bg-card rounded-2xl border p-6 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)] md:p-8">
      <h2 className="font-display mb-1 text-base">Sécurité</h2>
      <p className="text-muted-foreground mb-6 text-xs">
        Mot de passe et 2FA TOTP. 2FA optionnel mais fortement recommandé pour les Bidders.
      </p>
      <SecuritySettings />
    </section>
  );
}
